module.exports = __webpack_public_path__ + "img/2026-womens-retreat.bd7d5998.png";